/* eslint-disable no-param-reassign */
/* eslint-disable no-prototype-builtins */
// import store from "@/store";

class VuexCache
{
    /**
     * Initialize cache with module name
     * 
     * @param {string} module 
     */
    constructor(module, store)
    {
        this.module = module;
        this.cache = store;
    }

    /**
     * Get cache data from store
     * 
     * @param {string} key 
     * 
     * @returns Object|array
     */
    get(key)
    {
        return this.cache.getters[`${this.module}/get`](key);
    }

    set(key, value)
    {
        this.cache.commit(`${this.module}/SET`, {
            key,
            value
        });
    }

    remove(key)
    {
        this.cache.commit(`${this.module}/REMOVE`, key);
    }

    has(key)
    {
        try {
            return Object.keys(this.get(key)).length > 0;
        } catch(error) {
            return false;
        }
    }

    isExpired(key, expirationKey = 'expireAt')
    {
        const data = this.get(key);
        return data.hasOwnProperty(expirationKey) && (new Date(data[expirationKey]) < new Date());
    }

    /**
     * return cache data if exists, if does not exist set data by calling callback and set the cache
     * 
     * @param {string} key 
     * @param {*} value 
     */
    async rememberForever(key, callback)
    {
        if (this.has(key)) return this.get(key);

        const value = await callback();
        this.set(key, value);

        return value;
    }
    
    clearAll()
    {
        this.cache.commit(`${this.module}/RESET_STATE`);
    }
}

export default VuexCache;